import { InternalAxiosRequestConfig } from 'axios';

import { Global } from '@manage-cards/constants';
import {
	generateBrowserFingerprint,
	getFingerprintCookie,
} from '@manage-cards/utils/fingerPrint.utils';

export const attachAuthToken = (config: InternalAxiosRequestConfig) => {
	if (!config.headers) return config;
	const token = localStorage.getItem('AUTH_TOKEN');
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
};

export const attachBrowserFingerprint = async (
	request: InternalAxiosRequestConfig,
) => {
	let browserFingerprint = getFingerprintCookie();
	if (request && browserFingerprint) {
		request.headers[Global.FINGERPRINT_HEADER] = browserFingerprint;
		return Promise.resolve(request);
	}
	await generateBrowserFingerprint();
	browserFingerprint = getFingerprintCookie();
	request.headers[Global.FINGERPRINT_HEADER] = browserFingerprint;
	return Promise.resolve(request);
};
